(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var menuDrawer = document.querySelector('[data-menu-drawer]');
    var searchPanel = document.querySelector('[data-search-panel]');
    var body = document.body;

    function setOpen(element, open) {
      if (!element) return;
      element.hidden = !open;
      body.classList.toggle('drawer-open', open);
    }

    document.querySelectorAll('[data-menu-open]').forEach(function (button) {
      button.addEventListener('click', function () { setOpen(menuDrawer, true); });
    });
    document.querySelectorAll('[data-menu-close]').forEach(function (button) {
      button.addEventListener('click', function () { setOpen(menuDrawer, false); });
    });
    document.querySelectorAll('[data-search-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        setOpen(searchPanel, true);
        var input = searchPanel && searchPanel.querySelector('input[type="search"]');
        if (input) window.setTimeout(function () { input.focus(); }, 50);
      });
    });
    document.querySelectorAll('[data-search-close]').forEach(function (button) {
      button.addEventListener('click', function () { setOpen(searchPanel, false); });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        setOpen(menuDrawer, false);
        setOpen(searchPanel, false);
      }
    });

    document.querySelectorAll('[data-quantity-minus], [data-quantity-plus]').forEach(function (button) {
      button.addEventListener('click', function () {
        var input = button.parentElement && button.parentElement.querySelector('input[type="number"]');
        if (!input) return;
        var current = parseInt(input.value || '1', 10);
        var next = button.hasAttribute('data-quantity-plus') ? current + 1 : Math.max(1, current - 1);
        input.value = next;
      });
    });

    var sort = document.querySelector('[data-sort-by]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        window.location.href = url.toString();
      });
    }

    document.querySelectorAll('.quick-add-form').forEach(function (form) {
      form.addEventListener('submit', function () {
        var button = form.querySelector('button');
        if (button) {
          var original = button.innerHTML;
          button.innerHTML = 'Added';
          window.setTimeout(function () { button.innerHTML = original; }, 1200);
        }
      });
    });
  });
})();